export default "__VITE_ASSET__53b603b0__"